import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchCatalogProductsList,
  addProductLink,
  clearAddProductLink,
} from 'redux/catalog/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';

import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';
import { fixURL } from 'utils/fixURL';

import './AddCatalogProductForm.css';


const AddCatalogProductForm = props => {
  const {
    handleSubmit,
    valid,
    fetchCatalogProductsList,
    addProductLink,
    clearAddProductLink,
    addProductLinkSuccess,
    addProductLinkError,
    reset,
    url,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      clearAddProductLink();
    };
  }, []);

  useEffect(() => {
    fetchCatalogProductsList();
  }, [addProductLinkSuccess]);

  const _handleSubmit = values => {
    const urlValue = fixURL(values.url);
    addProductLink(urlValue);
    clearAddProductLink();
    reset();
  };

  return (
    <div className="add-catalog-product-form__component">
      <Form
        onSubmit={handleSubmit(_handleSubmit)}
        error={!valid}
      >
        {/* Url */}
        <div className="field-wrapper">
          <div className="icon" />
          <Field
            component={TextField}
            name="url"
            type="text"
            placeholder={t("Add the existing link to your product here")}
            required
          />

          <Button
            submit
            disabled={!url || !valid}
          >
            {t("Add")}
          </Button>
        </div>

        <Button
          submit
          disabled={!url || !valid}
        >
          + {t("Add Product")}
        </Button>

      </Form>

      {addProductLinkError &&
        <CommonMessage
          error
          errors={addProductLinkError}
        />
      }
    </div>
  );
};

AddCatalogProductForm.propTypes = {
  fetchCatalogProductsList: PropTypes.func.isRequired,
  addProductLink: PropTypes.func.isRequired,
  clearAddProductLink: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  addProductLinkSuccess: PropTypes.object,
  addProductLinkError: PropTypes.object,
  url: PropTypes.string,
};

AddCatalogProductForm.defaultProps = {
  addProductLinkSuccess: null,
  addProductLinkError: null,
  url: null,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('AddCatalogProductForm');
  return {
    url: selector(state, 'url'),
    addProductLinkSuccess: state.catalogReducer.addProductLinkSuccess,
    addProductLinkError: state.catalogReducer.addProductLinkError,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchCatalogProductsList,
    addProductLink,
    clearAddProductLink,
  },
)(reduxForm({
  form: 'AddCatalogProductForm',
  validate,
})(AddCatalogProductForm));
